import axios from 'axios';
import qs from 'qs';

let base = '';
let host = window.location.hostname;

//添加一个请求拦截器
axios.interceptors.request.use(function(config) {
    // 在发送请求之前做些什么
    var user = sessionStorage.getItem('user');
    var sessionName = "JSESSIONID";
    var sessionTmpVal = window.document.cookie.match('(^|;) ?' + sessionName + '=([^;]*)(;|$)');
    var currentSessionId = sessionTmpVal ? sessionTmpVal[2] : null;

    //console.log(user);
    if (user) {
        user = JSON.parse(user);
        //从本地COOKIE中获取JSESSIONID值
        //console.log("user.sessionid:" + user.sessionid);
        //console.log("currentSessionId:" + currentSessionId);
        if (user.sessionid != currentSessionId) {
            //清除token信息并跳转到登录页面
            sessionStorage.removeItem('user');
            //提示您已经超时，请重新登录
            location.href = "/#/login";
        }
    }

    return config;
}, function(error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});

//http response 拦截器
axios.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        if (error.response) {
            switch (error.response.status) {
                case 401:
                    //返回401,清除token信息并跳转到登录页面
                    sessionStorage.removeItem('user');
                    //提示您已经超时，请重新登录
                    location.href = "/#/login";
            }
        }
        return Promise.reject(error.response.data); //返回接口返回的错误信息
    });




//获取服务器端登陆验证码的配置状态信息
export const getLoginValidcodeStatusinfo = params => { return axios.get(`${base}/api/user/login/validcode/status/info`, { params: params }).then(res => res.data); };
//用户登录
export const requestLogin = params => { return axios.post(`${base}/api/user/login`, params).then(res => res.data); };
//用户退出
export const requestLogout = params => { return axios.get(`${base}/api/user/logout`, { params: params }).then(res => res.data); };
//获取某用户的详细信息
export const getUserInfo = params => { return axios.get(`${base}/api/user/detail`, { params: params }).then(res => res.data); };
//修改用户密码
export const editUserPwd = params => { return axios.get(`${base}/api/user/editpwd`, { params: params }).then(res => res.data); };
//修改用户手机号
export const editUserMobile = params => { return axios.get(`${base}/api/user/editmobile`, { params: params }).then(res => res.data); };
//获取用户卡的统计信息
export const getCardStat = params => { return axios.get(`${base}/api/report/cardstat`, { params: params }).then(res => res.data); };
//获取集团客户GPRS的统计信息
export const getGprsStat = params => { return axios.get(`${base}/api/report/gprsstat`, { params: params }).then(res => res.data); };



//获取模糊查询的服务商分页列表
export const getServicerListPage = params => { return axios.get(`${base}/api/user/likeusers`, { params: params }).then(res => res.data); };
//删除指定用户
export const removeUser = params => { return axios.get(`${base}/api/user/remove`, { params: params }); };
//修改指定用户
export const editUser = params => { return axios.post(`${base}/api/user/edit`, params); };
//增加新用户
export const addUser = params => { return axios.post(`${base}/api/user/add`, params).then(res => res.data); };


//获取模糊查询的入库分页列表
export const getInCardListPage = params => { return axios.get(`${base}/api/cards/likeinsku`, { params: params }).then(res => res.data); };
//删除卡号
export const removeCard = params => { return axios.get(`${base}/api/cards/remove`, { params: params }); };
//批量删除卡号
export const batchRemoveCard = params => { return axios.get(`${base}/api/cards/range/remove`, { params: params }).then(res => res.data); };

//查询即将到期的卡列表
export const getCarListByExpire = params => { return axios.get(`${base}/api/cards/getCarListByExpire`, { params: params }).then(res => res.data); };

//更新卡号到期时间
export const editCardExpiretime = params => { return axios.get(`${base}/api/cards/editCardExpiretime`, { params: params }); };

//获取模糊查询的出库分页列表
export const getOutCardListPage = params => { return axios.get(`${base}/api/cards/likeoutsku`, { params: params }).then(res => res.data); };
//出库卡号
export const outCard = params => { return axios.get(`${base}/api/cards/outsku`, { params: params }); };
//批量出库卡号
export const batchOutCard = params => {
    return axios.post(`${base}/api/cards/range/outsku`, qs.stringify(params), {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    }).then(res => res.data);
};

//获取用户拥有某个号段卡内的实际数量
//export const getUserOwnerCardnum = params => { return axios.get(`${base}/api/cards/range/skunum`, { params: params }).then(res => res.data); };

export const getUserOwnerCardnum = params => {
    return axios.post(`${base}/api/cards/range/skunum`, qs.stringify(params), {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    }).then(res => res.data);
};




//获取用户的直接下级服务商列表
export const getChildUsers = params => { return axios.get(`${base}/api/user/childusers`, { params: params }).then(res => res.data); };



//获取所有的套餐列表(临时的在卡号信息表中分组GROUPBY查出来的)
export const getPackList = params => { return axios.get(`${base}/api/dict/packlist`, { params: params }).then(res => res.data); };

//获取所有的对接第三方同步接口的应用编码列表
export const getAppsynList = params => { return axios.get(`${base}/api/dict/appsynlist`, { params: params }).then(res => res.data); };



//获取模糊查询所有卡号的分页列表
export const getCardListPage = params => { return axios.get(`${base}/api/cards/like`, { params: params }).then(res => res.data); };



//批量编辑卡号
export const batchEditCard = params => { return axios.get(`${base}/api/cards/range/edit`, { params: params }).then(res => res.data); };


//查询卡号详细信息
export const getCardDetail = params => { return axios.get(`${base}/api/cards/detail`, { params: params }).then(res => res.data); };

export const getLikeOneCardDetail = params => { return axios.get(`${base}/api/cards/m_userid/detail`, { params: params }).then(res => res.data); };


//上传导入EXCEL文件数据
// axios.post(url,form,{headers:headers})
export const impExcel = form => {
    return axios.post(`${base}/api/cards/excel/imp`, form, {
        method: 'post',
        headers: { 'Content-Type': 'multipart/form-data' }
    }).then(res => res.data);
};

//上传批量激活EXCEL文件数据
export const impExcelBatchActive = form => {
    return axios.post(`${base}/api/cards/excel/impbatchactive`, form, {
        method: 'post',
        headers: { 'Content-Type': 'multipart/form-data' }
    }).then(res => res.data);
};
//上传批量延期续费EXCEL文件数据
export const impExcelBatchexpire = form => {
    return axios.post(`${base}/api/cards/excel/impbatchexpire`, form, {
        method: 'post',
        headers: { 'Content-Type': 'multipart/form-data' }
    }).then(res => res.data);
};

//上传批量更改卡号的集团归属EXCEL文件数据
export const impExcelBatchApicode = form => {
    return axios.post(`${base}/api/cards/excel/impbatchapicode`, form, {
        method: 'post',
        headers: { 'Content-Type': 'multipart/form-data' }
    }).then(res => res.data);
};

//上传批更新卡号EXCEL文件数据
export const ImpBatchMsisdn = form => {
    return axios.post(`${base}/api/cards/excel/ImpBatchMsisdn`, form, {
        method: 'post',
        headers: { 'Content-Type': 'multipart/form-data' }
    }).then(res => res.data);
};

//上传批量修改套餐EXCEL文件数据
export const impExcelBatchPackage = form => {
    return axios.post(`${base}/api/cards/excel/impbatchpck`, form, {
        method: 'post',
        headers: { 'Content-Type': 'multipart/form-data' }
    }).then(res => res.data);
};

//上传批量更新充值金额信息
export const importPrice = form => {
    return axios.post(`${base}/api/cards/excel/importPrice`, form, {
        method: 'post',
        headers: { 'Content-Type': 'multipart/form-data' }
    }).then(res => res.data);
};
//批量预充值
export const bathRecharge = form => {
    return axios.post(`${base}/api/tRechargeTemp/excel/bathRecharge`, form, {
        method: 'post',
        headers: { 'Content-Type': 'multipart/form-data' }
    }).then(res => res.data);
};

//获取批量充值是否支付成功
export const getBatchRechargePaySuccess = params => { return axios.get(`${base}/api/tRechargeTemp/getpayissuccess`, { params: params }).then(res => res.data); };


//手动同步卡号信息
export const synCardDetail = params => { return axios.get(`${base}/api/cards/syncard`, { params: params }).then(res => res.data); };



//获取卡号自动同步时间
export const getSynTime = params => { return axios.get(`${base}/api/dict/getautosyntime`, { params: params }).then(res => res.data); };
//设置卡号自动同步时间
export const setSynTime = params => { return axios.get(`${base}/api/user/setsyntime`, { params: params }).then(res => res.data); };
//获取卡号自动同步时间
export const getSynTime_hebeijiucheng = params => { return axios.get(`http://${host}:18080/api/user/getautosyntime`, { params: params }).then(res => res.data); };
//设置卡号自动同步时间
export const setSynTime_hebeijiucheng = params => { return axios.get(`http://${host}:18080/api/user/setsyntime`, { params: params }).then(res => res.data); };




//查询充值列表
export const getOrderList = params => { return axios.post(`${base}/api/recharge/getOrderList`, params).then(res => res.data); };

//备注查询卡号
export const getCardByRemark = params => { return axios.post(`${base}/api/cards/getCardByRemark`, params).then(res => res.data); };

//充值详情分页查询
export const getRechargeDetail = params => { return axios.post(`${base}/api/recharge/getRechargeDetail`, params).then(res => res.data); };



//查询充值列表（新）
export const getRechargeList = params => { return axios.post(`${base}/api/recharge/getRechargeList`, params).then(res => res.data); };

//获取模糊查询套餐的分页列表
export const getPackListPage = params => { return axios.get(`${base}/api/package/like`, { params: params }).then(res => res.data); };

//获取所有的套餐列表
export const getAllPackList = params => { return axios.get(`${base}/api/package/getlist`, { params: params }).then(res => res.data); };

//新增套餐
export const savePakage = params => { return axios.post(`${base}/api/package/savePakage`, params).then(res => res.data); };

//删除指定套餐
export const delPakageById = params => { return axios.get(`${base}/api/package/delPakageById`, { params: params }).then(res => res.data); };

//查询充值汇总（加上服务商模糊查询）
export const getSummaryList = params => { return axios.get(`${base}/api/summary/getSummaryList`, { params: params }).then(res => res.data); };


//导出指定列表的卡信息
export const bathExportCard = params => { return axios.post(`${base}/api/cards/bathExportCard`, params).then(res => res.data); };

//批量回库
export const bathCardBack = params => { return axios.post(`${base}/api/cards/bathCardBack`, params).then(res => res.data); };

//批量开关机
export const bathsuspendCard = params => { return axios.post(`${base}/api/cards/bathsuspendCard`, params).then(res => res.data); };


//批量数据开关机
export const bathdataStateUp = params => { return axios.post(`${base}/api/cards/bathdataStateUp`, params).then(res => res.data); };

//批量转为计费期
export const bathtocharging = params => { return axios.post(`${base}/api/cards/bathtocharging`, params).then(res => res.data); };

//批量数据同步
export const bathDataSyn = params => { return axios.post(`${base}/api/cards/bathDataSyn`, params).then(res => res.data); };

//批量解绑

export const bathUntying = params => { return axios.post(`${base}/api/cards/bathUntying`, params).then(res => res.data); };


//删除定列表的卡
export const bathDelCards = params => { return axios.post(`${base}/api/cards/bathDelCards`, params).then(res => res.data); };



//获取模糊查询的集团客户API配置信息分页列表
export const getCompanyApiconfigListPage = params => { return axios.get(`${base}/api/companyapiconfig/like`, { params: params }).then(res => res.data); };
//修改指定集团客户API配置
export const editCompanyApiconfig = params => { return axios.post(`${base}/api/companyapiconfig/edit`, params); };
//增加新的集团客户API配置
export const addCompanyApiconfig = params => { return axios.post(`${base}/api/companyapiconfig/add`, params).then(res => res.data); };

//获取模糊查询所有已屏蔽用户余额的卡号的分页列表--预留
export const getNoBalanceCardListPage = params => { return axios.get(`${base}/api/cards/likeNoBalance`, { params: params }).then(res => res.data); };
//获取已屏蔽用户余额的卡号段的分页列表
export const getNoBalanceCardSegListPage = params => { return axios.get(`${base}/api/cards/balance/likeNoshow`, { params: params }).then(res => res.data); };
//增加屏蔽指定卡段内的卡号，在微信不能看用户余额
export const disabledShowBalanceCards = params => { return axios.get(`${base}/api/cards/balance/addNoshow`, { params: params }).then(res => res.data); };
//删除屏蔽指定卡段内的卡号，在微信不能看用户余额
export const enabledShowBalanceCards = params => { return axios.get(`${base}/api/cards/balance/delNoshow`, { params: params }).then(res => res.data); };

//更新卡的备注信息和到期时间
export const updateCardRemarkAndDate = params => { return axios.post(`${base}/api/cards/updateCardinfo`, params).then(res => res.data); };

//查询超出流量阀值的信息
export const getFlowInfo = params => { return axios.get(`${base}/api/excessflow/getAllinfo`, { params: params }).then(res => res.data); };

//查询超出流量阀值的信息
export const getFlowDetail = params => { return axios.get(`${base}/api/excessflow/getFlowDetail`, { params: params }).then(res => res.data); };

//查询预充值卡信息
export const getAllchargeInfo = params => { return axios.get(`${base}/api/tRechargeTemp/getAllchargeInfo`, { params: params }).then(res => res.data); };

//获取充值金额和订单编号
export const getrechargePrice = params => { return axios.get(`${base}/api/tRechargeTemp/getrechargePrice`, { params: params }).then(res => res.data); };

//获取移动短信列表
export const getSmsDetailCmcc = params => { return axios.get(`${base}/api/smsSend/getSmsDetailCmcc`, { params: params }).then(res => res.data); };

//发送短信
export const sendSms = params => { return axios.get(`${base}/api/smsSend/send`, { params: params }).then(res => res.data); };
//群发短信
export const sendSmsGroup = params => {
    return axios.post(`${base}/api/smsSend/groupsend`, qs.stringify(params), {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    }).then(res => res.data);
};



//获取模糊查询折扣类型的分页列表
export const getDiscountListPage = params => { return axios.get(`${base}/api/discount/kind/like`, { params: params }).then(res => res.data); };
//获取所有的折扣类型列表
export const getAllDiscount = params => { return axios.get(`${base}/api/discount/kind/all`, { params: params }).then(res => res.data); };
//新增折扣
export const addDiscount = params => { return axios.post(`${base}/api/discount/kind/add`, params).then(res => res.data); };
//修改折扣
export const editDiscount = params => { return axios.post(`${base}/api/discount/kind/edit`, params).then(res => res.data); };
//删除折扣
export const delDiscount = params => { return axios.get(`${base}/api/discount/kind/del`, { params: params }).then(res => res.data); };
//批量导入卡的折扣信息
export const editCardDiscount = params => {
    return axios.post(`${base}/api/discount/card/import`, qs.stringify(params), {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    }).then(res => res.data);
};
//批量删除卡的折扣信息
export const delCardDiscount = params => {
    return axios.post(`${base}/api/discount/card/del`, qs.stringify(params), {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    }).then(res => res.data);
};
//模拟查询折扣卡分页列表
export const getlikeDiscountCards = params => { return axios.get(`${base}/api/discount/card/like`, { params: params }).then(res => res.data); };


//获取全局公告记录
export const getNotice = params => { return axios.get(`${base}/api/notice/global/get`, { params: params }).then(res => res.data); };
//保存全局公告
export const saveNotice = params => { return axios.post(`${base}/api/notice/global/save`, params).then(res => res.data); };
//删除全局公告
export const delNotice = params => { return axios.get(`${base}/api/notice/global/del`, { params: params }).then(res => res.data); };

//根据用户id查询用户权限
export const getPath = params => { return axios.post(`${base}/api/role/getPath`, params).then(res => res.data); };

//获取角色列表
export const getRoleList = params => { return axios.get(`${base}/api/role/getRoleList`, { params: params }).then(res => res.data); };
//获取资源列表
export const getResourceList = params => { return axios.get(`${base}/api/resource/getResourceList`, { params: params }).then(res => res.data); };
//获取角色所拥有的菜单权限
export const getChecked = params => { return axios.get(`${base}/api/resource/getChecked`, { params: params }).then(res => res.data); };
//修改角色菜单权限
export const editRoleResource = params => { return axios.get(`${base}/api/resource/editRoleResource`, { params: params }).then(res => res.data); };

//批量调整阀值
export const bathAddFlow = params => { return axios.post(`${base}/api/cards/bathAddFlow`, params).then(res => res.data); };

//查询所有超过流量阀值数据停机卡号的分页列表
export const getStopDataCardListPage = params => { return axios.get(`${base}/api/cards/stopdata`, { params: params }).then(res => res.data); };

//批量购买流量包
export const bathBuyFlow = params => { return axios.post(`${base}/api/cards/bathBuyFlow`, params).then(res => res.data); };

// 获取叠加包列表
export const getGprsFlowPackage = params => { return axios.get(`${base}/api/package/getGprsFlowPackage`, { params: params }).then(res => res.data); };

//查询预购买叠加包
export const getAlladdGprsFlowInfo = params => { return axios.get(`${base}/api/tRechargeTemp/getAlladdGprsFlowInfo`, { params: params }).then(res => res.data); };

//获取叠加包支付总金额和订单编号
export const getAddGprsFlowPrice = params => { return axios.get(`${base}/api/tRechargeTemp/getAddGprsFlowPrice`, { params: params }).then(res => res.data); };

//获取使用量超过GPRS阈值的卡的数量
export const getOutgprsCardsTotal = params => { return axios.get(`${base}/api/cards/outgprs/todo`, { params: params }).then(res => res.data); };

// 待处理状态使用量超过GPRS阈值的卡进行数据停机操作
export const outgprsStop = params => { return axios.get(`${base}/api/cards/outgprs/stop`, { params: params }).then(res => res.data); };

// 一键处理所有待处理状态使用量超过GPRS阈值的卡进行数据停机操作
export const outgprsStopAll = params => { return axios.get(`${base}/api/cards/outgprs/stopAll`, { params: params }).then(res => res.data); };

//批量更新临时表续费周期和充值金额
export const updateRechargeMoney = params => { return axios.get(`${base}/api/tRechargeTemp/excel/updateRechargeMoney`, { params: params }).then(res => res.data); };

//根据卡号和续费周期查询续费金额
export const getMoneyByMisidnAndMonth = params => { return axios.get(`${base}/api/cards/getMoneyByMisidnAndMonth`, { params: params }).then(res => res.data); };

//获取流量池分页列表
export const getFlowPoolListPage = params => { return axios.get(`${base}/api/flowpool/like`, { params: params }).then(res => res.data); };
//修改流量池
export const editFlowPool = params => { return axios.post(`${base}/api/flowpool/edit`, params).then(res => res.data); };
//增加流量池
export const addFlowPool = params => { return axios.post(`${base}/api/flowpool/add`, params).then(res => res.data); };
//删除流量池
export const delFlowPool = params => { return axios.get(`${base}/api/flowpool/del`, { params: params }).then(res => res.data); };

//根据服务商获取流量池
export const getflowPoolList = params => { return axios.get(`${base}/api/flowpool/flowpoollist`, { params: params }).then(res => res.data); };
//流量池划转
export const transferCardToFlowpool = params => {
    return axios.post(`${base}/api/cards/transferCard/toFlowpool`, qs.stringify(params), {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    }).then(res => res.data);
};
//查询符合关联流量池的卡
export const getTransferCardCardnum = params => {
    return axios.post(`${base}/api/cards/transferCard/skunum`, qs.stringify(params), {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    }).then(res => res.data);
};

//获取一级服务商列表
export const getUserOneList = params => { return axios.get(`${base}/api/user/getUserOneList`, { params: params }).then(res => res.data); };

//删除流量池已划拨的卡
export const delCardFromFlowpool = params => {
    return axios.post(`${base}/api/cards/transferCard/delCard`, qs.stringify(params), {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    }).then(res => res.data);
};

//获取流量池分页列表
export const getFlowReportFormListPage = params => { return axios.get(`${base}/api/flowpool/flowReportForm`, { params: params }).then(res => res.data); };

//根据流量池和用户id查询流量池关联卡列表
export const getCardListByFlowpool = params => { return axios.get(`${base}/api/flowpool/cardlist`, { params: params }).then(res => res.data); };

//根据流量池和用户id查询流量池关联所有卡数量
export const getCardCount = params => { return axios.get(`${base}/api/flowpool/getCardCount`, { params: params }).then(res => res.data); };

//主页根据状态查询卡分页列表
export const getCardListPageByState = params => { return axios.get(`${base}/api/main/Cards/cardstatelist`, { params: params }).then(res => res.data); };

//主页查询已到期卡分页列表
export const getCardListPageByExpire = params => { return axios.get(`${base}/api/main/Cards/likeExpireCards`, { params: params }).then(res => res.data); };

//主页查询流量预警卡分页列表
export const getCardListPageByWarming = params => { return axios.get(`${base}/api/main/Cards/likeWarmingCards`, { params: params }).then(res => res.data); };


// WEBPACK FOOTER //
// ./src/api/api.js